// @file Composable that provides methods for draggable posts
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import { useSurfacePostsDragAndDropStore } from '@@/pinia/surface_posts_drag_and_drop'
import type { OnDropPayload } from '@@/pragmatic-drag-and-drop/helpers'
import type { Post, WallGroupPost } from '@@/types'
import { storeToRefs } from 'pinia'

export const useSurfacePostSectionDraggableHelper = (): {
  canDropPostIntoSection: typeof canDropPostIntoSection
  dropPostIntoSection: typeof dropPostIntoSection
} => {
  const surfacePostsStore = useSurfacePostsStore()
  const { allSortedPostsByGroup } = storeToRefs(surfacePostsStore)
  const { isAPostDragging, groupIdUnderPostBeingDragged, isDraggingPostInNonManuallySortedWall } = storeToRefs(
    useSurfacePostsDragAndDropStore(),
  )

  function canDropPostIntoSection(groupId: number | string): boolean {
    // If the wall is non-manually sorted, we allow dropping posts into the section
    if (isDraggingPostInNonManuallySortedWall.value) return true
    const posts = allSortedPostsByGroup.value[groupId]
    if (posts && posts.length > 0) return false
    // If the wall is manually sorted, we allow dropping posts into the section if the section is empty
    return true
  }

  function dropPostIntoSection(e: OnDropPayload<{ post: Post }, { section: WallGroupPost }>): void {
    isAPostDragging.value = false
    groupIdUnderPostBeingDragged.value = undefined
    const sourcePost = e.sourceItem.data.post
    const targetGroupId = e.targetItem.data.section.id
    surfacePostsStore.updatePostGroup({
      postCid: sourcePost.cid,
      groupId: targetGroupId,
    })
  }

  return {
    canDropPostIntoSection,
    dropPostIntoSection,
  }
}
